import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetSalesState, getSales as onGetSaless } from "../../../store/sales/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { getBranch, resetBranchState } from "../../../store/actions";

const CATEGORY_TYPE = {
  BANK: "bank",
  BOOKING: "booking",
  KANTOR: "kantor",
  SP3KFINAL: "sp3k-final",
  STBBANK: "stb-bank",
};

const ReportSalesDaily = () => {
  const [pageIdx, setPageIdx] = useState(0);
  const [salesDoc, setSalesDoc] = useState([]);
  const dispatch = useDispatch();

  const { saless, isSalesCreated, isSalesSuccess, loading, error, companies, companyLoading, branches, branchLoading } = useSelector((state) => ({
    saless: state.Sales.saless,
    isSalesCreated: state.Sales.isSalesCreated,
    isSalesSuccess: state.Sales.isSalesSuccess,
    loading: state.Sales.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    error: state.Sales.error,
  }));

  const [salesList, setSalesList] = useState([]);
  const [sales, setSales] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [categoryActive, setCategoryActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [companyName, setCompanyName] = useState({});
  const [searchBranch, setSearchBranch] = useState("");
  const [branchList, setBranchList] = useState([]);

  const statusCategoryData = [
    {
      options: [
        { label: "BOOKING", value: CATEGORY_TYPE.BOOKING },
        { label: "BANK", value: CATEGORY_TYPE.BANK },
        { label: "KANTOR", value: CATEGORY_TYPE.KANTOR },
        { label: "SP3K FINAL", value: CATEGORY_TYPE.SP3KFINAL },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");

  const mergedDataList = useRef([]);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const handleTypeFilterSales = (type) => {
    return saless.filter((sales) => sales.statusDealId === type && sales.typeId !== 4 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5));
  };

  const handleKategoryFilter = (type) => {
    if (mergedDataList.current) {
      const filterData = mergedDataList.current.filter((data) => data.type === type);
      setSalesList(filterData);
    }
  };

  const toggleBranch = (val) => {
    setSearchValue("");
    setCategoryActive({ label: "BOOKING", value: CATEGORY_TYPE.BOOKING });
    setFilterDate(null);
    dispatch(onGetSaless({ branchId: val }));
  };

  const handleGetBranch = (companyId) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    const bankFilter = handleTypeFilterSales(5);
    const bookingFilter = handleTypeFilterSales(3);
    const kantorFilter = handleTypeFilterSales(4);
    const sp3kFinalFilter = handleTypeFilterSales(7);
    // console.log(bookingData, "booking");
    const bankData = bankFilter.map((data) => {
      const blockName = data?.sales_detail[0]?.sales_detail_product?.product_block?.name ?? "-";
      const typeBlockName = data?.sales_detail[0]?.sales_detail_product?.name ?? "-";
      return {
        name: data?.sls_appl?.name ?? "-",
        block: `${blockName} - ${typeBlockName}`,
        tgl_masuk_bank: data?.sls_appl?.applicationAt ?? "-",
        sales: data?.sales_agent?.name ?? "-",
        branch: data?.sales_branch?.name ?? "-",
        description: data?.description ?? "-",
        type: CATEGORY_TYPE.BANK,
      };
    });

    const bookingData = bookingFilter.map((data) => {
      const paymentMethod = data?.sales_trans.find((t) => t.id === 1367)?.description ?? "-";
      const fee = data?.sales_trans.find((t) => t.id === 1367)?.amount ?? "0";
      return {
        name: data?.sls_appl?.name ?? "-",
        booking_fee: fee,
        booking_via: paymentMethod,
        tgl_booking: data?.transactionat ?? "-",
        sales: data?.sales_agent?.name ?? "-",
        branch: data?.sales_branch?.name ?? "-",
        description: data?.description ?? "-",
        type: CATEGORY_TYPE.BOOKING,
      };
    });

    const kantorData = kantorFilter.map((data) => {
      const blockName = data?.sales_detail[0]?.sales_detail_product?.product_block?.name ?? "-";
      const typeBlockName = data?.sales_detail[0]?.sales_detail_product?.name ?? "-";
      return {
        name: data?.sls_appl?.name ?? "-",
        block: `${blockName} - ${typeBlockName}`,
        tgl_masuk_kantor: data?.docat ?? "-",
        sales: data?.sales_agent?.name ?? "-",
        description: data?.description ?? "-",
        type: CATEGORY_TYPE.KANTOR,
      };
    });

    const mergedData = [...bankData, ...bookingData, ...kantorData];

    mergedDataList.current = mergedData;
    // console.log(mergedData, "OKKK");

    handleCategorySelect({ label: "BOOKING", value: CATEGORY_TYPE.BOOKING });
  }, [saless]);

  useEffect(() => {
    if (!isSearch) {
      // dispatch(onGetSaless({ id: "1", ok: "ok" }, "/sales-daily"));
      dispatch(onGetSaless({ branchId: 2 }));
    }
    setIsSearch(true);
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (obj.data && obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role) {
      setCompanyName({
        label: obj?.data?.user.user_company.name,
        value: obj?.data?.user.user_company.id,
      });
      setRoles(obj?.data?.user?.user_position?.position_role.method);
    } else setRoles(null);

    ///
    setSearchBranch({ value: obj.data.companyId, label: "PESONA KAHURIPAN 13" });
    ///
    handleGetBranch(obj.data.companyId);
    if (obj?.data) setUserType(obj?.data?.userType);
  }, [dispatch, saless, isSearch]);

  function handleCompany(e) {
    if (e.length > 2) {
      const param = { title: e, status: 2 };
      dispatch(getCompany(param));
    }
    return false;
  }

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, sbum: parseFloat(item.sbum) };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    setSales(saless);
  }, [saless]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transactionat",
        label: "TANGGAL PEMBAYARAN",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_customer",
        label: "NAMA DEBITUR",
        isSelected: true,
        data: [],
      },
      {
        id: "at_branch",
        label: "LOKASI",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_agent",
        label: "SALES",
        isSelected: true,
        data: [],
      },
      {
        id: "at_pm",
        label: "KETERANGAN TRANSAKSI",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "JUMLAH BAYAR",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "KETERANGAN",
        isSelected: true,
        data: [],
      },
    ];

    if (salesList.length > 0) {
      salesList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "at_branch" || doc.id === "sales_customer" || doc.id === "at_pm" || doc.id === "sales_agent") {
                doc.data.push(value?.name ?? "");
              } else if (doc.id === "amount") {
                doc.data.push(currencyFormat(value === null ? 0 : value));
              } else if (doc.id === "transactionat") {
                doc.data.push(handleValidDate(value));
              } else {
                doc.data.push(value);
              }
            } else if (key === "at_sales") {
              const sales_customer = dataDoc.find((d) => d.id === "sales_customer");
              sales_customer.data.push(value?.sales_customer?.name ?? "");

              const sales_agent = dataDoc.find((d) => d.id === "sales_agent");
              sales_agent.data.push(value?.sales_agent?.name ?? "");
            }
          });
        }
      });
    }

    setSalesDoc(dataDoc);
  }, [salesList]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = salesList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setSalesList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = salesList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setSalesList(updatedData);
                }} />
            </div>
          );
        },
      },
      {
        Header: "Name",
        accessor: "name",
        filterable: true,
      },

      ...(categoryActive?.value === CATEGORY_TYPE.BOOKING
        ? [
            {
              Header: "Biaya Booking",
              accessor: "booking_fee",
              filterable: true,
              Cell: (data) => {
                return currencyFormat(data.row.original.booking_fee === null ? 0 : data.row.original.booking_fee);
              },
            },
            {
              Header: "VIA",
              accessor: "booking_via",
              filterable: true,
            },
            {
              Header: "Tanggal Booking",
              accessor: "tgl_booking",
              filterable: true,
              Cell: (data) => {
                return data.row.original.tgl_booking ? handleValidDate(data.row.original.tgl_booking, "D/MM/YYYY") : "";
              },
            },
          ]
        : []),
      ...(categoryActive?.value === CATEGORY_TYPE.BANK
        ? [
            {
              Header: "Blok",
              accessor: "block",
              filterable: true,
            },
            {
              Header: "Tanggal Masuk Bank",
              accessor: "tgl_masuk_bank",
              filterable: true,
              Cell: (data) => {
                return data.row.original.tgl_masuk_bank ? handleValidDate(data.row.original.tgl_masuk_bank, "D/MM/YYYY") : "";
              },
            },
          ]
        : []),
      ...(categoryActive?.value === CATEGORY_TYPE.KANTOR
        ? [
            {
              Header: "Blok",
              accessor: "block",
              filterable: true,
            },
            {
              Header: "Tanggal Masuk Kantor",
              accessor: "tgl_masuk_kantor",
              filterable: true,
              Cell: (data) => {
                return data.row.original.tgl_masuk_kantor ? handleValidDate(data.row.original.tgl_masuk_kantor, "D/MM/YYYY") : "";
              },
            },
          ]
        : []),
      {
        Header: "SALES",
        accessor: "sales",
        filterable: true,
      },
      {
        Header: "Cabang",
        accessor: "branch",
        filterable: true,
      },
      {
        Header: "KETERANGAN",
        accessor: "description",
        filterable: true,
      },
    ],
    [salesList, isCheckAll, categoryActive]
  );


  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = salesList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setSalesList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => salesList, [salesList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleCategorySelect(data) {
    handleKategoryFilter(data?.value);
    setCategoryActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    // var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      // status: status,
    };
    dispatch(onGetSaless(param));
  }

  document.title = "Laporan Penjualan | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={salesList} />
      <Container fluid>
        <BreadCrumb title="Laporan Harian" pageTitle="Penjualan" />
        <Row>
          <Col lg={12}>
            <Card id="salesList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Data Laporan &nbsp;
                    {isLoading ? (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    ) : (
                      ""
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <ExportDoc data={salesDoc} />
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={3} xl={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                            gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}/>
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2} xl={2}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}/>
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={categoryActive}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  handleCategorySelect(e);
                                }}
                                options={statusCategoryData}
                                name="choices-single-default"></Select>
                            </div>
                          </Col>

                          <Col sm={3}>
                            <Select
                              name="searchBranch"
                              value={searchBranch}
                              placeholder="Filter Proyek"
                              onChange={(e) => {
                                setSearchBranch(e);
                                toggleBranch(e.value);
                              }}
                              options={branchList}></Select>
                          </Col>

                          <Col sm={1}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr className={""} key={index} {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">
                      {rows.length} Data
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ReportSalesDaily;
